import * as types from '../../action-types';
import {deleteEmployment as initialState } from "../../initialState";

const deleteEmployment = (state=initialState, action) => {
  switch (action.type) {
    case types.DELETE_EMPLOYMENT_START:
      return {
        ...state,
        isLoading: true
      };
    case types.DELETE_EMPLOYMENT_SUCCESS:
      return {
        ...state,
        isLoading: false,
        isSuccessful: true,
        data: action.payload
      };
    case types.DELETE_EMPLOYMENT_FAIL:
      return {
        ...state,
        isLoading: false,
        error: action.payload
      };
    case types.DELETE_EMPLOYMENT_CLEANUP:
      return {
        ...state,
        isLoading: false,
        isSuccessful: false,
        error: null
      };
    default:
      return state;
  }
}

export default deleteEmployment;
